/**
 * Dashboard-only layout tokens (2026-style: soft elevation, tight type scale, responsive grids).
 * Complements portal teal palette; used by UserDashboard / OnboardingDashboard.
 */

export const dashboardPage = 'max-w-[min(1200px,100%)] mx-auto space-y-8 lg:space-y-10 pb-2';

/** Hero band behind greeting — subtle depth without heavy chrome. */
export const dashboardHero =
  'relative overflow-hidden rounded-3xl border border-portal-teal/10 ' +
  'bg-gradient-to-br from-pure-white via-background-blu to-portal-header-wash/25 ' +
  'px-6 py-8 sm:px-10 sm:py-10 ' +
  'shadow-[0_12px_40px_-18px_rgba(0,75,77,0.22)]';

/** Dark teal product band matching limehealth.uk Population Pulse feature bar. */
export const pulseHero =
  'relative overflow-hidden rounded-3xl bg-portal-teal text-pure-white ' +
  'px-6 py-8 sm:px-10 sm:py-10 ' +
  'shadow-[0_12px_40px_-18px_rgba(0,75,77,0.35)]';

export const pulseHeroGrid =
  'mt-8 grid grid-cols-1 gap-px overflow-hidden rounded-2xl bg-pure-white/15 sm:grid-cols-4';

export const pulseHeroCell = 'bg-portal-teal px-4 py-5 text-center sm:px-5 sm:py-6';

export const dashboardGrid =
  'grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6 xl:grid-cols-3 xl:gap-7';

/** Default KPI / text card. */
export const dashboardStatCard =
  'relative flex flex-col overflow-hidden rounded-2xl border border-portal-teal/10 bg-pure-white ' +
  'px-5 py-6 sm:px-7 sm:py-7 ' +
  'shadow-[0_8px_28px_-10px_rgba(0,75,77,0.14)] ' +
  'transition-[box-shadow,transform] duration-300 ease-out ' +
  'hover:shadow-[0_14px_36px_-12px_rgba(0,75,77,0.2)] hover:-translate-y-0.5';

/** Full-width chart / gauge strip spanning the grid. */
export const dashboardWideCard = `${dashboardStatCard} sm:col-span-2 xl:col-span-3`;

export const dashboardStatLabel =
  'text-[11px] font-semibold uppercase tracking-[0.16em] text-portal-teal/65';

export const dashboardStatValue =
  'mt-3 text-2xl sm:text-3xl font-sans-co font-bold tracking-tight text-portal-teal leading-tight';

export const dashboardMuted =
  'text-p2 text-portal-teal/75 leading-relaxed';

export const utcDataDisclaimer = 'All data is shown in the UTC timezone.';

export const dashboardAlert =
  'rounded-xl border border-error-red/25 bg-action-required/40 px-4 py-3 text-p2 text-primary-text';

/** Member KPI cards: track + ring around @ramonak/react-progress-bar. */
export const dashboardMemberProgressShell =
  'rounded-full bg-portal-header-wash/80 p-1.5 ring-1 ring-portal-teal/10';

/** Percentage readout beside the member KPI bar (true value; bar may use a visual floor when low). */
export const dashboardMemberProgressPercentAside =
  'shrink-0 tabular-nums text-[12px] font-semibold text-portal-teal sm:text-[13px]';
